'use client';

import { PlotlyChart } from './PlotlyChart';
import type { MetricsSample } from '../types';
import { sortPods } from '../ChartContext';

interface Props { samples: MetricsSample[]; loading?: boolean }

export function AgreedLimitChart({ samples, loading }: Props) {
  const pods = sortPods(Array.from(new Set(samples.map((s) => s.pod))));
  const byPod = new Map<string, { x: Date[]; y: number[] }>();
  for (const pod of pods) byPod.set(pod, { x: [], y: [] });
  for (const s of [...samples].sort((a, b) => a.ts_ms - b.ts_ms)) {
    const v = s.limit_to_publish;
    if (v == null || v <= 0) continue;
    const series = byPod.get(s.pod);
    if (!series) continue;
    series.x.push(new Date(s.ts_ms));
    series.y.push(v);
  }
  const traces = pods.map((pod) => {
    const series = byPod.get(pod)!;
    return {
      x: series.x,
      y: series.y,
      type: 'scatter' as const,
      mode: 'lines' as const,
      name: pod,
      connectgaps: false,
    };
  });
  return (
    <PlotlyChart
      traces={traces}
      yTitle="req/s"
      yRange={[0, 110]}
      legendSortDirection="asc"
      loading={loading}
    />
  );
}
